import { AISummaryResponse } from '@/api/ai-api';
import { Skeleton } from '@/components/ui/Skeleton';

interface AISummaryPanelProps {
  summary?: AISummaryResponse;
  isLoading: boolean;
  isError: boolean;
}

export function AISummaryPanel({ summary, isLoading, isError }: AISummaryPanelProps) {
  if (isLoading) {
    return (
      <div className="animate-pulse space-y-4 p-4">
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="p-4 text-center">
        <p className="text-red-500">Erro ao gerar resumo clínico</p>
      </div>
    );
  }

  if (!summary) {
    return (
      <div className="p-4 text-center text-gray-500">
        <p>Clique em "Gerar Resumo" para iniciar</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <pre className="whitespace-pre-wrap text-sm text-gray-700 font-sans">
          {JSON.stringify(summary.summary, null, 2)}
        </pre>
      </div>

      {summary.suggestions.length > 0 && (
        <div className="space-y-2">
          <h4 className="text-sm font-semibold text-gray-900">Sugestões Geradas</h4>
          {summary.suggestions.map((s, i) => (
            <div key={i} className="bg-blue-50 rounded-lg border border-blue-200 p-3">
              <span className="text-xs font-medium text-blue-700 uppercase">{s.type}</span>
              {s.confidence && (
                <span className="text-xs text-blue-500 ml-2">
                  Confiança: {(s.confidence * 100).toFixed(0)}%
                </span>
              )}
            </div>
          ))}
        </div>
      )}

      <div className="text-xs text-gray-400">
        Tokens: {summary.tokenUsage.totalTokens} | Custo: R$ {summary.tokenUsage.cost.toFixed(6)}
      </div>
    </div>
  );
}
